export default "__VITE_ASSET__DQv3U93s__"